import { render, staticRenderFns } from "./ViewGroupTextHistoryStats.vue?vue&type=template&id=72c48e91&scoped=true&"
import script from "./ViewGroupTextHistoryStats.vue?vue&type=script&lang=ts&"
export * from "./ViewGroupTextHistoryStats.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c48e91",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
